<template>
    <v-window v-model="question" touchless>
        <v-window-item v-for="(question, index) in questions" :key="index" eager>
            <v-row>
                <v-col cols="12" class="text-center" style="height: 80px;">
                    <div class="headline white--text">{{question.question}}</div>
                </v-col>
            </v-row>
            <v-col style="width: 35vh" class="mx-auto">
                <v-row justify="center">
                    <v-col cols="12" v-for="(answer, questionIndex) in question.answers" :key="questionIndex">
                        <v-card @click="answerQuestion(index, questionIndex)">
                            <VImg :src="answer.photo" aspect-ratio="1" eager/>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-row>
                <v-col cols="12" class="text-center white--text">
                    <div>Vraag {{index+1}}/{{questions.length}}</div>
                </v-col>
            </v-row>
        </v-window-item>
    </v-window>
</template>

<script>

import questions from '../quiz/questions.js';
import {whoAmI} from '../quiz/quiz.js';

export default {
    name: 'Home',
    data() {
        return {
            questions: [],
            answers: [],
            question: 0,
        };
    },
    watch: {
        question() {
            if (this.question === questions.length) {
                this.endQuiz();
            }
        },
    },
    created() {
        this.questions = questions;
    },
    methods: {
        answerQuestion(questionId, answerId) {
            this.answers[questionId] = answerId;
            this.question++;
        },
        endQuiz() {
            this.$router.push({name: 'outro', query: this.answers});
        }
    },
};
</script>
